import { EventSender } from '@libs/analytics/EventSender'
import generateStatsLabelString from '@resources/js/helpers/generateStatsLabelString'

const clickunderSender = new EventSender({
	category: 'clickunder',
	events: ['open'],
})

const sendClickunderStats = ({
	type = null,
	partnerUrl = null,
	additionalParams = {},
} = {}) => {
	const customLabelString = generateStatsLabelString({
		type,
		partnerUrl,
		additionalParams,
	})

	clickunderSender.send('open', { category: 'clickunder', customLabelString })
}

export default sendClickunderStats
